export default __webpack_public_path__ + "static/media/twentyFourPieces8.797a4aa3.jpg";